import type { ClothingDefinition, ClothingSlot, WardrobeState } from '../../../core/domain/types';

export function equipClothing(
  wardrobe: WardrobeState,
  definition: ClothingDefinition,
  preview: boolean,
): WardrobeState {
  const target = { ...(preview ? (wardrobe.preview ?? wardrobe.equipped) : wardrobe.equipped) };
  target[definition.slot] = definition.id;
  for (const conflict of definition.conflictSlots) delete target[conflict];

  return preview
    ? { ...wardrobe, preview: target }
    : { ...wardrobe, equipped: target, preview: null };
}

export function randomOutfit(
  ownedIds: string[],
  definitions: ClothingDefinition[],
  random: () => number = Math.random,
): Partial<Record<ClothingSlot, string>> {
  const owned = definitions.filter((item) => ownedIds.includes(item.id));
  const output: Partial<Record<ClothingSlot, string>> = {};
  const dress = owned.filter((item) => item.slot === 'dress');
  const useDress = dress.length > 0 && random() > 0.5;
  const slots: ClothingSlot[] = useDress
    ? ['dress', 'shoes', 'hat']
    : ['top', 'bottom', 'shoes', 'hat'];
  for (const slot of slots) {
    const choices = owned.filter((item) => item.slot === slot);
    const choice = choices[Math.floor(random() * choices.length)];
    if (choice) output[slot] = choice.id;
  }
  return output;
}
